export const help = {
    totalNetInvested: 'Total net amount invested, valued at cost (subscriptions minus redemptions). Uses weighted average if multiple subscriptions. Excludes fund yield.',
    nbOfShares: 'Number of shares you own in the fund',
    totalValue: 'Value of investments at last reporting date',
    allocation: 'Allocation calculated by USD value',
    pastMonthPerf: 'Past month performance',
    ytd: 'Year to date',
    itd: 'Inception to date',
    valueUsd: 'USD value of subscription on date of subscription',
};
